var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58594 12.75H9.58594V9.75H12.5859V7.75H9.58594V4.75H7.58594V7.75H4.58594V9.75H7.58594V12.75ZM8.58594 20.75C5.9026 18.4667 3.8986 16.3457 2.57394 14.387C1.2486 12.429 0.585938 10.6167 0.585938 8.95C0.585938 6.45 1.39027 4.45833 2.99894 2.975C4.60694 1.49167 6.46927 0.75 8.58594 0.75C10.7026 0.75 12.5649 1.49167 14.1729 2.975C15.7816 4.45833 16.5859 6.45 16.5859 8.95C16.5859 10.6167 15.9236 12.429 14.5989 14.387C13.2736 16.3457 11.2693 18.4667 8.58594 20.75Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopsIcon);
export default __webpack_public_path__ + "static/media/stops_icon.9a113757e0228b16f36f30139e31a80f.svg";
export { ForwardRef as ReactComponent };